import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class BusinessDaysWidgetVm {
	businessDaysSetCount: number;
	sitesClosedCount: number;
	businessDaysNotSetCount: number;
	percentSet: number;
	percentClosed: number;
	percentNotSet: number;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'businessDaysSetCount': new UntypedFormControl(0, [...(validators['businessDaysSetCount'] ?? []), ...[Validators.required]]),
			'sitesClosedCount': new UntypedFormControl(0, [...(validators['sitesClosedCount'] ?? []), ...[Validators.required]]),
			'businessDaysNotSetCount': new UntypedFormControl(0, [...(validators['businessDaysNotSetCount'] ?? []), ...[Validators.required]]),
			'percentSet': new UntypedFormControl(0, [...(validators['percentSet'] ?? []), ...[Validators.required]]),
			'percentClosed': new UntypedFormControl(0, [...(validators['percentClosed'] ?? []), ...[Validators.required]]),
			'percentNotSet': new UntypedFormControl(0, [...(validators['percentNotSet'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): BusinessDaysWidgetVmFromFg {
		return new BusinessDaysWidgetVmFromFg(fg);
	}
}

export class BusinessDaysWidgetVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get businessDaysSetCount(): number {
		return this.fg.get('businessDaysSetCount').value;
	}
	set businessDaysSetCount(val) {
		this.fg.get('businessDaysSetCount').setValue(val);
	}

	get sitesClosedCount(): number {
		return this.fg.get('sitesClosedCount').value;
	}
	set sitesClosedCount(val) {
		this.fg.get('sitesClosedCount').setValue(val);
	}

	get businessDaysNotSetCount(): number {
		return this.fg.get('businessDaysNotSetCount').value;
	}
	set businessDaysNotSetCount(val) {
		this.fg.get('businessDaysNotSetCount').setValue(val);
	}

	get percentSet(): number {
		return this.fg.get('percentSet').value;
	}
	set percentSet(val) {
		this.fg.get('percentSet').setValue(val);
	}

	get percentClosed(): number {
		return this.fg.get('percentClosed').value;
	}
	set percentClosed(val) {
		this.fg.get('percentClosed').setValue(val);
	}

	get percentNotSet(): number {
		return this.fg.get('percentNotSet').value;
	}
	set percentNotSet(val) {
		this.fg.get('percentNotSet').setValue(val);
	}
}
